export const SET_LOCAL_PARTICIPANT = 'SET_LOCAL_PARTICIPANT'
export const SET_LOCAL_ZOOM = 'SET_LOCAL_ZOOM'
